import React from 'react';

import { connect } from 'react-redux';
import * as actions from 'actions';

import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Badge from 'material-ui/Badge';

import getAvatar, { getInitialsString } from '../utils/avatarUtils';

import { uniqObj } from '../utils/lodashUtils';

import { constants } from '../constants';

class ClientListItems extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            gotCount: false
        }
    }
    
    componentDidMount() {
        this.props.clients.map(client => {
            this.getUnreadCount(client);
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.unreadContentCount !== nextProps.unreadContentCount) {
            this.props.clients.map(client => {
                this.getUnreadCount(client);
            })
        }
    }

    getUnreadCount = (client) => {
        if (!this.state.gotCount) {
            // console.log('GETTING CLIENT UNREADS COUNTS FOR CLIENT LIST', client.uid);
            
            this.props.checkUnreadsForUserClient(this.props.userId, client.uid);
            this.setState({
                gotCount: true
            });
        }
    }
    
    render() {
        const { 
            clients, 
            onClientSelect, 
            header = null, 
            divider = null,
        } = this.props;
        
        if (!clients) {
            // console.error('ERROR: You need to pass in a valid "clients" prop for ClientListItems to display clients.' );
            return null;
        }

        const uniqClients = uniqObj(clients); // TODO: Find the reason why clients are being doubled. This is a temporary fix. 
        
        // console.log('CLIENTS @ CLIENT LIST',  clients, clients[0]);
        // const providerClients = map(clients, client => client);
        // console.log('CLIENTS ARRAY', providerClients);
        return (
            <div>
                { header &&
                    <Subheader>{ header }</Subheader>
                }
                { uniqClients.length > 0 &&
                    <div>
                         { uniqClients.map((client, i) => {
                            // console.log('CLIENT IN LIST ###############', client)
    
                            return (
                                <div key={i}>
                                    <ListItem
                                        key={client.uid}
                                        leftAvatar={
                                            <Avatar 
                                                color={(i % 2 === 0) ? `white` : `rgba(0,0,0,0.5)`} 
                                                backgroundColor={(i % 2 === 0) ? `${constants.color.primary}` : `${constants.color.secondary}`} 
                                                src={(client.profilePhotoURL) ? client.profilePhotoURL : null }
                                            >
                                                { client && !client.profilePhotoURL &&
                                                    <div style={{ position: 'relative', top: 2 }}>
                                                        {getInitialsString(client.firstName, client.lastName)}
                                                    </div>
                                                }
                                            </Avatar>
                                        }
                                        rightIcon={
                                            <Badge
                                                badgeContent={this.props.unreadContentCount && this.props.unreadContentCount[client.uid] && this.props.unreadContentCount[client.uid].count}
                                                secondary={true}
                                                // badgeStyle={{ top: -12, right: -12 }}
                                                style={{ display: (this.props.unreadContentCount && this.props.unreadContentCount[client.uid] && this.props.unreadContentCount[client.uid].count) ? 'block' : 'none' }}
                                            />
                                        }
                                        primaryText={`${client.firstName} ${client.lastName}`}
                                        // secondaryText={`with ${provider.name.first} ${provider.name.last}`}
                                        style={{ maxWidth: '100%', textOverflow: 'ellipsis', backgroundColor: (this.props.unreadContentCount && this.props.unreadContentCount[client.uid] && this.props.unreadContentCount[client.uid].count > 0) ? 'rgba(200,200,200, 0.3)' : 'transparent' }}
                                        onClick={() => onClientSelect(client, i)}
                                    />
                                </div>
                            );
                        })} 
                    </div>
                }
                { divider &&
                    <Divider />
                }
            </div>
        );
    }
}

const mapStateToProps = ({ notification, auth }) => {
    // console.log('UNREADS', notification.unreadCount);
    
    return {
        unreadContentCount: notification.unreadCount && notification.unreadCount,
        userId: auth.authData.id,
    };
};

export default connect(mapStateToProps, actions)(ClientListItems);


// WEBPACK FOOTER //
// ./src/js/components/ClientListItems.jsx